/**
 * Created by Ning Jiang on 8/22/2018.
 */

import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";

export class IceIceYetiReels extends Reels {

    public static ReelAreaView:ReelAreaView;

    constructor() {
        super();
        IceIceYetiReels.ReelAreaView = Reels._reelAreaView;
    }
}